import '../CsvJsonInfoPages.scss';


function UsedPrices() {

     const data = [
    { length: 1, description: 'CAP Vehicle Code' },
    { length: 2, description: 'CAP Vehicle Identification Number' },
    { length: 3, description: 'Version Change Date (ddmmyyyy)' },
    { length: 4, description: 'Year' },
    { length: 5, description: 'Registration Letter' },
    { length: 6, description: 'New Price at registration period (##########.####)' },
    { length: 7, description: 'Low Mileage (Kms for HEAVIES)' },
    { length: 8, description: 'Retail' },
    { length: 9, description: 'Clean' },
    { length: 10, description: 'Average' },
    { length: 11, description: 'Below Average' },
    { length: 12, description: '1st Standard Mileage (Kms for HGV)' },
    { length: 13, description: 'Retail' },
    { length: 14, description: 'Clean' },
    { length: 15, description: 'Average' },
    { length: 16, description: 'Below Average' },
    { length: 17, description: '2nd Standard Mileage (Kms for HGV)' },
    { length: 18, description: 'Retail' },
    { length: 19, description: 'Clean' },
    { length: 20, description: 'Average' },
    { length: 21, description: 'Below Average' },
    { length: 22, description: '3rd Standard Mileage (Kms for HGV)' },
    { length: 23, description: 'Retail' },
    { length: 24, description: 'Clean' },
    { length: 25, description: 'Average' },
    { length: 26, description: 'Below Average' },
    { length: 27, description: '1st High Mileage (Kms for HGV)' },
    { length: 28, description: 'Retail' },
    { length: 29, description: 'Clean' },
    { length: 30, description: 'Average' },
    { length: 31, description: 'Below Average' },
    { length: 32, description: '2nd High Mileage (Kms for HGV)' },
    { length: 33, description: 'Retail' },
    { length: 34, description: 'Clean' },
    { length: 35, description: 'Average' },
    { length: 36, description: 'Below Average' },
    { length: 37, description: 'CC of vehicle' },
    { length: 38, description: 'Insurance Group 1 (Only Used in CARS and BIKES)' },
    { length: 39, description: 'Insurance Group 2 (Only Used in BIKES)' },
    { length: 40, description: 'Introduction Date (ddmmyyyy)' },
  ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Used Values - Used Prices</h1>
            <p> Provides current used values data at each registration period with up to six mileage points covering Retail value, CAP Clean, Average and Below average condition.<br /><br />
                <b>File Naming Convention</b></p>
            <p> The &lt;FILENAME&gt; is dependant on the product being produced as follows</p>
            <p>
                CPRVAL.??? CARS<br />
                LPRVAL.??? LIGHT COMMERCIALS<br />
                HPRVAL.??? HEAVY COMMERCIALS<br />
                BPRVAL.??? BIKES<br />
                IPRVAL.??? IMPORTED CARS<br />
                MPRVAL.??? MOTORISED CARAVANS<br /><br/>

                The 3 question marks (???) on each of the above files will be replaced with the month i.e. MAR for March.<br />
             
            </p>
       <table>
      <thead>
        <tr>
          <th>Field</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>{item.length}</td>
            <td>{item.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
        </div>
    );
}

export default UsedPrices;
